import { Auth } from 'aws-amplify';
import AppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import { OperationVariables } from 'aws-appsync/node_modules/apollo-client';
import { DocumentNode, GraphQLError, printError } from 'graphql';

import awsexports from '../../aws-exports';

export const client = new AppSyncClient({
  url: awsexports.aws_appsync_graphqlEndpoint,
  region: awsexports.aws_appsync_region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
  },
  disableOffline: true,
});

export async function query<V extends OperationVariables, Q>(query: DocumentNode, variables?: V) {
  try {
    const result = await client.query<Q>({
      query,
      variables,
    });

    if (result.errors && result.errors.length) {
      // eslint-disable-next-line no-throw-literal
      throw { graphQLErrors: result.errors };
    }

    return result.data;
  } catch (error: any) {
    if (error.graphQLErrors) {
      error.graphQLErrors.forEach((error: GraphQLError) => {
        console.error(printError(error));
      });
    } else {
      console.error(error);
    }

    throw new Error('query failed!');
  }
}

export async function mutation<V extends OperationVariables, M>(mutation: DocumentNode, variables?: V) {
  try {
    const result = await client.mutate<M>({
      mutation,
      variables,
    });

    if (result.errors && result.errors.length) {
      // eslint-disable-next-line no-throw-literal
      throw { graphQLErrors: result.errors };
    }

    return result.data;
  } catch (error: any) {
    if (error.graphQLErrors) {
      error.graphQLErrors.forEach((error: GraphQLError) => {
        console.error(printError(error));
      });
    } else {
      console.error(error);
    }

    throw new Error('mutation failed!');
  }
}
